<style></style>
<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">
          Progress Report
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            리포트 관리 → MyPath → Progress Report
          </div>
        </h5>

        <query-grid :config="config">
          <template #items="props">
            <tr
              v-for="record in props.records"
              v-bind:key="record.id"
              :class="{ 'table-danger': record.is_deleted }"
            >
              <td scope="row">A-{{ record.id }}</td>
              <td>
                <Business v-if="record.t2" :biz="record.t2" />
              </td>
              <td>
                <!--a href="#" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
                  @click="moreStudentInfo(record)">{{ record.username }}</a-->
                {{ record.username }}
              </td>
              <td>
                <Student :student="record" />
              </td>
              <td>{{ record.level }}</td>
              <td>
                <button
                  class="btn btn-danger btn-sm"
                  data-bs-toggle="modal"
                  data-bs-target=".detail"
                  v-on:click="
                    clearReport();
                    this.report_contents.student = record;
                  "
                >
                  Report
                </button>
              </td>
            </tr>
          </template>
        </query-grid>

        <!--학습리포트-->
        <div
          class="modal fade detail"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">
                  마이패스 리포트
                </h5>
              </div>
              <div class="modal-body">
                <P style="font-size: 14px">
                  해당리포트는 학습기록 데이터가 아니기 때문에저장되지
                  않습니다.<br />
                  <span style="font-weight: bold"
                    >저장을 원하실경우 PDF저장(결과지보기->출력->프린터를 PDF로
                    설정)</span
                  >하셔서 활용하시기 바랍니다.
                </P>
                <table class="table pa">
                  <colgroup>
                    <col style="width: 17%; background: #333" />
                    <col style="width: 33%" />
                    <col style="width: 17%" />
                    <col style="width: 33%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th scope="row">회원명</th>
                      <td>{{ report_contents.student.name }}</td>
                      <th scope="row">등록년월</th>
                      <td>{{ report_contents.student.createdAt }}</td>
                    </tr>
                    <tr>
                      <th colspan="row">
                        <i class="fas fa-check-circle"></i>학습진도
                        <button
                          type="button"
                          class="btn btn-secondary btn-sm"
                          style="padding: 2px 4px"
                          data-bs-toggle="modal"
                          data-bs-target=".bd-example-modal-lg-modify-content"
                        >
                          수정
                        </button>
                      </th>

                      <td colspan="3">
                        <table class="table report">
                          <colgroup>
                            <col style="width: 50%" />
                            <col style="width: 50%" />
                          </colgroup>
                          <tr>
                            <th
                              scope="row"
                              v-for="(v, name) in report_contents.progress"
                              :key="name"
                            >
                              {{ name }} (완료/전체)
                            </th>
                          </tr>
                          <tr>
                            <td
                              scope="row"
                              style="background: #fff !important"
                              v-for="(v, name) in report_contents.progress"
                              :key="name"
                            >
                              {{ (v.current / v.total) * 100 }}% ({{
                                v.current
                              }}
                              / {{ v.total }})
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <i class="fas fa-check-circle"></i>전달내용
                        <button
                          type="button"
                          class="btn btn-secondary btn-sm"
                          style="padding: 2px 4px"
                          data-bs-toggle="modal"
                          data-bs-target=".bd-example-modal-lg-modify-content"
                        >
                          수정
                        </button>
                      </th>
                      <td colspan="3">
                        <table class="table report">
                          <tbody>
                            <tr>
                              <td style="border-top: none; border-bottom: none">
                                {{ report_contents.text }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>

                    <tr
                      v-for="(data, name) in report_contents.progress"
                      :key="name"
                    >
                      <th scope="row">{{ name }}<br /></th>
                      <td colspan="3">
                        <table class="table report">
                          <tbody>
                            <colgroup>
                              <col style="width: 20%" />
                              <col style="width: 40%" />
                              <col style="width: 20%" />
                              <col style="width: 20%" />
                            </colgroup>
                            <tr>
                              <th scope="row">레벨</th>
                              <th scope="row">항목</th>
                              <th scope="row">진행율</th>
                              <th scope="row">진행상태</th>
                            </tr>
                            <template
                              v-for="(ginfo, index) in data.details"
                              :key="index"
                            >
                              <tr
                                v-for="(detail, i) in ginfo.contents"
                                :key="i"
                              >
                                <td :rowspan="ginfo.contents.length" v-if="!i">
                                  {{ ginfo.name }}<br />
                                  <button
                                    type="button"
                                    class="btn btn-secondary btn-sm"
                                    style="padding: 2px 4px"
                                    data-bs-toggle="modal"
                                    data-bs-target=".bd-example-modal-lg-modify"
                                    @click="enterModify(name, ginfo)"
                                  >
                                    수정
                                  </button>
                                </td>
                                <td style="text-align: left">
                                  {{ detail.name }}
                                </td>
                                <td>{{ detail.progress }}%</td>
                                <td>
                                  <span
                                    class="text_passed"
                                    v-if="detail.status == 'passed'"
                                    >Passed</span
                                  >
                                  <span
                                    class="text_inprogress"
                                    v-if="detail.status == 'in_progress'"
                                    >In-Progress</span
                                  >
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="table report">
                  <tbody>
                    <tr>
                      <th rowspan="2">
                        <i class="fas fa-check-circle"></i>학습내용(추가)
                      </th>
                      <td style="text-align: left">
                        <select v-model="creates.subject" class="select2">
                          <option value="" selected>과목 선택</option>
                          <option v-for="(v, k) in curri" :key="k" :value="k">
                            {{ k }}
                          </option>
                        </select>
                        <select
                          v-if="creates.subject"
                          class="select2"
                          v-model="creates.grade"
                        >
                          <option value="" selected>레벨 선택</option>
                          <option
                            v-for="(v, k) in curri[creates.subject]"
                            :key="k"
                            :value="k"
                          >
                            {{ k }}
                          </option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <table
                          width="100%"
                          border="0"
                          v-if="creates.subject && creates.grade"
                        >
                          <tbody>
                            <tr>
                              <td>항목</td>
                              <td>진행율</td>
                              <td>진행상태</td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr
                              v-for="(activity, i) in curri[creates.subject][
                                creates.grade
                              ]"
                              :key="i"
                            >
                              <td>{{ activity }}</td>
                              <td>
                                <input
                                  type="text"
                                  style="width:100px; height:25px; border-radius:0px padding:4px; "
                                  class="input"
                                  v-model="creates.contents[activity]"
                                />
                              </td>
                              <td>
                                <select
                                  v-model="
                                    creates.contents[activity + '_status']
                                  "
                                  style="border: 1px solid #ccc; padding: 4px"
                                >
                                  <option value="passed">완료</option>
                                  <option value="in_progress">진행중</option>
                                </select>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style="text-align: right">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    @click="addCreates()"
                  >
                    학습내용 등록
                  </button>
                </div>
              </div>
              <div>
                <div class="flex_center">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    닫 기
                  </button>

                  <button
                    type="button"
                    class="mgl10 btn btn-success"
                    data-bs-toggle="modal"
                    data-bs-target=".detail_print"
                    href="#myModal2"
                  >
                    결과지 보기
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--수정 클릭시 모달-->
        <div
          class="modal fade bd-example-modal-lg-modify"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-modal="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <!--<div class="modal-header" style="background:#fff;">
                                                    <h5 class="modal-title" id="exampleModalLabel"></h5>
                                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                </div>-->
              <div class="modal-body">
                <table width="100%" border="0">
                  <colgroup>
                    <col style="width: 20%" />
                    <col style="width: 30%" />
                    <col style="width: 20%" />
                    <col style="width: 30%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td class="td_type01">과목</td>
                      <td class="td_type02">{{ modify_obj.subject }}</td>
                      <td class="td_type01">레벨</td>
                      <td class="td_type02">{{ modify_obj.name }}</td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <table width="100%" border="0">
                  <tbody>
                    <tr>
                      <td class="td_type01">항목</td>
                      <td class="td_type01">진행율</td>
                      <td class="td_type01">진행상태</td>
                    </tr>
                    <tr v-for="(activity, i) in modify_obj.contents" :key="i">
                      <td class="td_type02">{{ activity.name }}</td>
                      <td class="td_type02">
                        <input
                          type="text"
                          style="width: 100px; height: 25px"
                          class="input"
                          v-model="activity.progress"
                        />
                      </td>
                      <td class="td_type02">
                        <select v-model="activity.status">
                          <option value="in_progress">진행중</option>
                          <option value="passed">완료</option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="modal-footer" style="border-top: none">
                <button
                  type="button"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>

        <!--전달내용 수정 클릭시 모달-->
        <div
          class="modal fade bd-example-modal-lg-modify-content"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-modal="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <!--<div class="modal-header" style="background:#fff;">
                                                    <h5 class="modal-title" id="exampleModalLabel"></h5>
                                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                </div>-->
              <div class="modal-body">
                <table class="table report">
                  <colgroup>
                    <col style="width: 20%" />
                    <col style="width: 20%" />
                    <col style="width: 30%" />
                    <col style="width: 30%" />
                  </colgroup>
                  <tbody>
                    <!--tr>
                                                      <td class="td_type01">리포트번호</td>
                                                      <td class="td_type02">R1000</td>
                                                      <td class="td_type01">등록(수정)일</td>
                                                      <td class="td_type02">2022-01-03 17:22</td>
                                                    </tr-->
                    <tr>
                      <th>학습진도</th>
                      <td colspan="3">
                        <table class="table report">
                          <tbody>
                            <tr>
                              <th
                                v-for="(v, name) in report_contents.progress"
                                :key="name"
                              >
                                {{ name }} (완료/전체)
                              </th>
                            </tr>
                            <tr>
                              <td
                                v-for="(v, name) in report_contents.progress"
                                :key="name"
                              >
                                <input
                                  type="text"
                                  class="input"
                                  v-model="v.current"
                                  style="
                                    width: 40px;
                                    text-align: center;
                                    margin-right: 6px;
                                  "
                                />/<input
                                  type="text"
                                  class="input"
                                  v-model="v.total"
                                  style="
                                    width: 40px;
                                    text-align: center;
                                    margin-left: 6px;
                                  "
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <th>전달내용</th>
                      <td colspan="3">
                        <textarea
                          v-model="report_contents.text"
                          style="
                            width: 90%;
                            height: 200px;
                            border: 1px solid #f0f0f0;
                            margin: 10px;
                            background: #f8f8f8;
                            padding: 10px;
                          "
                        ></textarea>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="modal-footer" style="border-top: none">
                <button
                  type="button"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade detail_print"
          id="myModal2"
          tabindex="-2"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          style="display: none; z-index: 1060"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <!-- <div class="modal-header">
                                            <h5 class="modal-title" id="exampleModalLongTitle">2번째모달</h5>
                                            </div>-->
              <div class="modal-body">
                <body style="background: #ccc">
                  <div id="printThis" class="mypath_wrap">
                    <div class="logo_wrap"></div>
                    <div class="cont_wrap">
                      <div class="cont_wrap_box" style="width: 100%">
                        <div
                          class="cont_wrap_wrap"
                          style="
                            display: inline-block;
                            width: calc(100% - 255px);
                            vertical-align: top;
                          "
                        >
                          <!-- Student's Information -->
                          <div class="title" style="background: green">
                            Student's Information
                          </div>

                          <table
                            class="type_inform"
                            style="margin: 10px 0; background: lightpink"
                          >
                            <colgroup>
                              <col style="width: 15%" />
                              <col style="width: 35%" />
                              <col style="width: 15%" />
                              <col style="width: 35%" />
                            </colgroup>
                            <tr>
                              <td class="sub_title4">Academy</td>
                              <td v-if="this.report_contents.student.t2">
                                {{ this.report_contents.student.t2.name }}
                              </td>
                              <td class="sub_title4">Date</td>
                              <td>{{ new Date() }}</td>
                            </tr>
                            <tr>
                              <td class="sub_title4">Name</td>
                              <td>{{ this.report_contents.student.name }}</td>
                              <td class="sub_title4">ID</td>
                              <td>
                                {{ this.report_contents.student.username }}
                              </td>
                            </tr>
                          </table>
                          <ul>
                            <li class="mgl5 hiding" style="font-size: 0.9em">
                              <span class="color_r">■</span
                              ><span>69% and below</span>
                              <span class="color_y">■</span
                              ><span>70% - 79%</span>
                              <span class="color_g">■</span
                              ><span>80% or better</span>
                            </li>
                          </ul>
                        </div>
                        <div
                          class="graph_wrap_wrap"
                          style="
                            display: inline-block;
                            width: 250px;
                            float: right;
                          "
                        >
                          <div class="graph_wrap">
                            <div class="graph">
                              <!-- 기준 -->
                              <ul class="y-axis">
                                <li><span>100</span></li>
                                <li><span>80</span></li>
                                <li><span>60</span></li>
                                <li><span>40</span></li>
                                <li><span>20</span></li>
                                <li><span>0</span></li>
                              </ul>
                              <!-- 목록 -->
                              <ul class="x-axis">
                                <li
                                  style="
                                    display: inline-block;
                                    width: 100px;
                                    text-align: center;
                                  "
                                >
                                  <span>Reading</span>
                                </li>
                                <l
                                  style="
                                    ddisplay: inline-block;
                                    width: 100px;
                                    text-align: center;
                                  "
                                  ><span>Math</span></l
                                >
                              </ul>
                              <!-- 바 그래프 (백분율 만큼 heigh값) -->
                              <ul class="bar">
                                <li
                                  style="margin-left: 20px"
                                  :style="{
                                    height:
                                      (report_contents.progress.Reading
                                        .current /
                                        report_contents.progress.Reading
                                          .total) *
                                        100 +
                                      '%',
                                  }"
                                >
                                  <span class="bg_red"></span>
                                </li>
                                <li
                                  style="margin-left: -10px"
                                  :style="{
                                    height:
                                      (report_contents.progress.Math.current /
                                        report_contents.progress.Math.total) *
                                        100 +
                                      '%',
                                  }"
                                >
                                  <span class="bg_blue"></span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <template
                        v-for="(v, name) in report_contents.progress"
                        :key="name"
                      >
                        <!-- Reading -->
                        <div class="title">
                          <ul>
                            <li>{{ name }}</li>
                            <li style="text-align: right; font-size: 0.9em">
                              {{ Math.floor((v.current / v.total) * 100) }}% ({{
                                v.current
                              }}
                              / {{ v.total }})
                            </li>
                          </ul>
                        </div>
                        <!-- Reading_Sub -->
                        <template
                          v-for="gradeInfo in v.details"
                          :key="gradeInfo.name"
                        >
                          <div class="title_sub">
                            <ul>
                              <li>{{ gradeInfo.name }}</li>
                              <li style="text-align: right; font-size: 0.9em">
                                <span class="color_r">■</span
                                ><span>69% and below</span>
                                <span class="color_y">■</span
                                ><span>70% - 79%</span>
                                <span class="color_g">■</span
                                ><span>80% or better</span>
                              </li>
                            </ul>
                          </div>
                          <table class="type_inform2">
                            <colgroup>
                              <col style="width: 30%" />
                              <col style="width: 50%" />
                              <col style="width: 20%" />
                            </colgroup>
                            <tbody>
                              <tr>
                                <td class="sub_title4">DOMAIN</td>
                                <td class="sub_title4">PROGRESS</td>
                                <td class="sub_title4">STATUS</td>
                              </tr>

                              <tr
                                class="alignC"
                                v-for="(activity, i) in gradeInfo.contents"
                                :key="i"
                              >
                                <td>{{ activity.name }}</td>
                                <td class="alignL">
                                  <div class="progress">
                                    <div
                                      class="progress-bar"
                                      role="progressbar"
                                      :class="{
                                        color_b_r: activity.progress < 70,
                                        color_b_y:
                                          activity.progress >= 70 &&
                                          activity.progress < 80,
                                        color_b_g: activity.progress >= 80,
                                      }"
                                      :style="{
                                        width: activity.progress + '%',
                                      }"
                                      :aria-valuenow="activity.progress"
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    >
                                      {{ activity.progress }}%
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <template v-if="activity.status == 'passed'"
                                    >Passed</template
                                  >
                                  <template
                                    v-if="activity.status == 'in_progress'"
                                    >In-Progress</template
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </template>
                      </template>

                      <!-- Comment -->
                      <div class="title">Comments</div>
                      <table
                        class="type_inform"
                        style="margin: 10px 0 40px 0px"
                      >
                        <tbody>
                          <tr>
                            <td style="padding: 10px 20px">
                              {{ report_contents.text }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <!-- Domain -->
                      <div class="title">Domain Definition</div>
                      <table class="type_inform">
                        <colgroup>
                          <col style="width: 15%" />
                          <col style="width: 15%" />
                          <col style="width: 30%" />
                          <col style="width: 30%" />
                        </colgroup>
                        <tbody>
                          <tr>
                            <td class="sub_title4">Subject</td>
                            <td class="sub_title4">Level</td>
                            <td class="sub_title4" colspan="2">Domain</td>
                          </tr>

                          <template
                            v-for="(v, name) in report_contents.progress"
                            :key="name"
                          >
                            <template
                              v-for="gradeInfo in v.details"
                              :key="gradeInfo.name"
                            >
                              <tr
                                v-for="(activity, i) in gradeInfo.contents"
                                :key="i"
                              >
                                <td>{{ name }}</td>
                                <td>{{ gradeInfo.name }}</td>
                                <td>{{ activity.name }}</td>
                                <td>{{ korDic[activity.name] }}</td>
                              </tr>
                            </template>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </body>
                <div class="flex_center">
                  <button @click="printIt()" class="btn btn-primary">
                    출력
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import QueryGrid from "../components/QueryGrid";
import Business from "../components/Business";
import Student from "../components/detail_pages/Student";
import axios from "axios";
import printJS from "print-js";

export default {
  name: "Home",
  components: {
    Business,
    Student,
    QueryGrid,
  },
  mounted() {},
  methods: {
    printIt() {
      printJS({
        printable: "printThis",
        type: "html",
        css: ["./print_report.css"],
        scanStyles: false,
      });
    },
    addCreates() {
      var obj = {
        name: this.creates.grade,
        contents: [],
      };
      this.curri[this.creates.subject][this.creates.grade].forEach((v) => {
        if (this.creates.contents[v]) {
          obj.contents.push({
            name: v,
            progress: this.creates.contents[v],
            status: this.creates.contents[v + "_status"] || "in_progress",
          });
        }
      });

      this.report_contents.progress[this.creates.subject].details.push(obj);
      this.creates = {
        subject: "",
        grade: "",
        contents: {},
      };
    },
    enterModify(subject, obj) {
      this.modify_obj = {
        ...obj,
        subject: subject,
      }; // obj 안에 있는 array는 참조해버리는데(복사가 아니라) 이게 의도한 게 맞으므로 버그아님!!수정하지마세요!!!!!
    },
    clearReport() {
      this.report_contents = {
        student: {
          name: "",
          createdAt: "",
        },
        progress: {
          Reading: {
            current: 0,
            total: 0,
            details: [],
          },
          Math: {
            current: 0,
            total: 0,
            details: [],
          },
        },
        text: "",
      };
    },
  },
  data() {
    return {
      modify_obj: {
        subject: "",
        grade: "",
        contents: [],
      },
      korDic: {
        "Reading: Foundational Skills": "읽기: 기본적인 기술",
        "Reading: Literature": "읽기: 문학",
        "Reading: Informational Text": "읽기: 정보성 글 (비문학)",
        Language: "언어",
        "Counting & Cardinality": "수와 집합",
        "Operation And Algebraic Thinking": "연산과 대수적 사고",
        "Number and Operations Base Ten": "수와 10진법수 연산",
        "Measurement and Data": "측정과 데이터",
        Geometry: "기하",
        "Number and Operations-Fractions": "수와 연산-분수",
        "The Number System": "수 체계",
        "Ratios & Proportional Relationships": "비와 비례관계",
        "Expressions & Equations": "식과 방정식",
        Functions: "함수",
        "Number & Quantity": "수와 수량",
        Algebra: "대수",
        "Geometry-Congruence": "기하-합동",
        "Geometry-Expressing Geometric Properties with Equations":
          "기하-방정식으로 기하하적 속성 표현",
        "Geometry-Modeling with Geometry": "기하-기하 모델링 ",
        "Geometry-Similarity, Right Triangles, & Trigonometry":
          "기하-유사성, 직각 삼각형 및 삼각법",
        "The Complex Number System": "복소수 시스템",
        "Algebra- Seeing Structure in Expressions": "대수-방정식에서 구조 파악",
      },
      curri: {
        Reading: {
          GK: [
            "Reading: Foundational Skills",
            "Reading: Literature",
            "Reading: Informational Text",
          ],
          GR1: [
            "Reading: Foundational Skills",
            "Reading: Literature",
            "Reading: Informational Text",
          ],
          GR2: [
            "Reading: Foundational Skills",
            "Reading: Literature",
            "Reading: Informational Text",
          ],
          GR3: [
            "Reading: Foundational Skills",
            "Reading: Literature",
            "Reading: Informational Text",
            "Language",
          ],
          GR4: [
            "Reading: Foundational Skills",
            "Reading: Literature",
            "Reading: Informational Text",
            "Language",
          ],
          GR5: [
            "Reading: Foundational Skills",
            "Reading: Literature",
            "Reading: Informational Text",
            "Language",
          ],
          GR6: ["Reading: Literature", "Reading: Informational Text"],
          GR7: ["Reading: Literature", "Reading: Informational Text"],
          GR8: ["Reading: Literature", "Reading: Informational Text"],
          GR9: ["Reading: Literature", "Reading: Informational Text"],
          GR10: ["Reading: Literature", "Reading: Informational Text"],
          GR11: ["Reading: Literature", "Reading: Informational Text"],
          GR12: ["Reading: Literature", "Reading: Informational Text"],
        },
        Math: {
          GK: [
            "Counting & Cardinality",
            "Operation And Algebraic Thinking",
            "Number and Operations Base Ten",
            "Measurement and Data",
            "Geometry",
          ],
          GR1: [
            "Number and Operations Base Ten",
            "Operation And Algebraic Thinking",
            "Measurement and Data",
          ],
          GR2: [
            "Number and Operations Base Ten",
            "Operation And Algebraic Thinking",
            "Measurement and Data",
            "Geometry",
          ],
          GR3: [
            "Number and Operations Base Ten",
            "Operation And Algebraic Thinking",
            "Number and Operations-Fractions",
            "Measurement and Data",
          ],
          GR4: [
            "Number and Operations Base Ten",
            "Operation And Algebraic Thinking",
            "Number and Operations-Fractions",
            "Measurement and Data",
            "Geometry",
          ],
          GR5: [
            "Number and Operations Base Ten",
            "Operation And Algebraic Thinking",
            "Number and Operations-Fractions",
            "Measurement and Data",
            "Geometry",
          ],
          GR6: [
            "The Number System",
            "Ratios & Proportional Relationships",
            "Expressions & Equations",
            "Geometry",
          ],
          GR7: [
            "The Number System",
            "Ratios & Proportional Relationships",
            "Expressions & Equations",
            "Geometry",
          ],
          GR8: ["Expressions & Equations", "Functions", "Geometry"],
          GR9: ["Number & Quantity", "Algebra", "Functions"],
          GR10: [
            "Geometry-Congruence",
            "Geometry-Expressing Geometric Properties with Equations",
            "Geometry-Modeling with Geometry",
            "Geometry-Similarity, Right Triangles, & Trigonometry",
          ],
          GR11: [
            "The Complex Number System",
            "Algebra- Seeing Structure in Expressions",
            "Functions",
            "Geometry-Similarity, Right Triangles, & Trigonometry",
          ],
          GR12: [
            "The Complex Number System",
            "Algebra- Seeing Structure in Expressions",
            "Functions",
            "Geometry-Similarity, Right Triangles, & Trigonometry",
          ],
        },
      },
      creates: {
        subject: "",
        grade: "",
        contents: {},
      },
      report_contents: {
        student: {
          name: "",
          createdAt: "",
        },
        progress: {
          Reading: {
            current: 0,
            total: 0,
            details: [],
          },
          Math: {
            current: 0,
            total: 0,
            details: [],
          },
        },
        text: "",
      },
      config: {
        name: "마이패스리포트_학생리스트",
        req_endpoint: "/students",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },
          {
            id: "status_filter",
            name: "유형",
            type: "switch",
            filter_type: {
              ACTIVE: "정회원",
              EVENT: "이벤트회원",
              INACTIVE: "미사용(퇴원)",
            },
          },
          {
            id: "level_filter",
            name: "레벨",
            type: "switch",
            filter_type: {
              GK: "GK",
              GR1: "GR1",
              GR2: "GR2",
              GR3: "GR3",
              GR4: "GR4",
              GR5: "GR5",
              GR6: "GR6",
              GR7: "GR7",
              GR8: "GR8",
              GR9: "GR9",
              GR10: "GR10",
              GR11: "GR11",
              GR12: "GR12",
            },
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder: "아이디/이름/회원번호",
          },
        ],
        columns: [
          {
            id: "id",
            sortable: true,
            name: "회원번호",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "class",
            name: "클래스",
            excel_print: (v) => {
              return v.t1.name;
            },
          },
          {
            id: "username",
            sortable: true,
            name: "아이디",
            excel_print: (v) => {
              return v.username;
            },
          },
          {
            id: "hanname",
            sortable: true,
            name: "이름",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "level",
            sortable: true,
            name: "레벨",
            excel_print: (v) => {
              return v.level || "";
            },
          },
          {
            id: "액션",
            name: "액션",
          },
        ],
        extras_addon: async () => {
          return '&prod_filter=["MYPATH"]&status_filter=["ACTIVE", "EVENT"]';
        },
      },
    };
  },
};
</script>
